import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/summary-dex-not-match.svg'
import _imports_1 from '@/app/ui/assets/svg/summary-dispute-requested.svg'
import _imports_2 from '@/app/ui/assets/svg/summary-dispute-approved.svg'
import _imports_3 from '@/app/ui/assets/svg/summary-dispute-rejected.svg'
import _imports_4 from '@/app/ui/assets/svg/summary-dispute-accept.svg'


const _hoisted_1 = { class: "py-4 grid grid-cols-5 gap-4" }
const _hoisted_2 = { class: "flex flex-row p-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "max-w-none w-16",
  alt: "total-dex"
}, null, -1)
const _hoisted_4 = { class: "pl-4 flex flex-col pt-3" }
const _hoisted_5 = { class: "font-semibold text-12px text-gray-lp-600 whitespace-nowrap" }
const _hoisted_6 = { class: "text-20px font-semibold" }
const _hoisted_7 = { class: "flex flex-row p-4 cursor-pointer" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "max-w-none w-16",
  alt: "total-dex"
}, null, -1)
const _hoisted_9 = { class: "pl-4 flex flex-col pt-3" }
const _hoisted_10 = { class: "flex flex-row p-4 cursor-pointer" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "max-w-none w-16",
  alt: "total-dex"
}, null, -1)
const _hoisted_12 = { class: "pl-4 flex flex-col pt-3" }
const _hoisted_13 = { class: "flex flex-row p-4 cursor-pointer" }
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "max-w-none w-20",
  alt: "total-dex"
}, null, -1)
const _hoisted_15 = { class: "pl-4 flex flex-col pt-3" }
const _hoisted_16 = { class: "flex flex-row p-4 cursor-pointer" }
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "max-w-none w-16",
  alt: "total-dex"
}, null, -1)
const _hoisted_18 = { class: "pl-4 flex flex-col pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('dexAssessment.summaryTicketInvalid')), 1),
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.data.ticketInvalid), 1)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Card, {
      onClick: _cache[1] || (_cache[1] = () => _ctx.onClickSummary('requested')),
      class: `${_ctx.isRequestedActive ? 'bg-red-lp-100' : ''}`
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            _createVNode("div", {
              class: 
              `font-semibold text-12px ${
                _ctx.isRequestedActive ? 'text-white' : 'text-gray-lp-600'
              } whitespace-nowrap`
            
            }, _toDisplayString(_ctx.$t('dexAssessment.summaryDisputeRequested')), 3),
            _createVNode("div", {
              class: 
              `text-20px font-semibold ${_ctx.isRequestedActive ? 'text-white' : ''}`
            
            }, _toDisplayString(_ctx.data.ticketDisputeRequested) + "/" + _toDisplayString(_ctx.data.ticketInvalid), 3)
          ])
        ])
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_Card, {
      onClick: _cache[2] || (_cache[2] = () => _ctx.onClickSummary('approved')),
      class: `${_ctx.isApprovedActive ? 'bg-red-lp-100' : ''}`
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode("div", _hoisted_12, [
            _createVNode("div", {
              class: 
              `font-semibold text-12px ${
                _ctx.isApprovedActive ? 'text-white' : 'text-gray-lp-600'
              } whitespace-nowrap`
            
            }, _toDisplayString(_ctx.$t('dexAssessment.summaryDisputeApproved')), 3),
            _createVNode("div", {
              class: 
              `text-20px font-semibold ${_ctx.isApprovedActive ? 'text-white' : ''}`
            
            }, _toDisplayString(_ctx.data.ticketDisputeApproved) + "/" + _toDisplayString(_ctx.data.ticketInvalid), 3)
          ])
        ])
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_Card, {
      onClick: _cache[3] || (_cache[3] = () => _ctx.onClickSummary('rejected')),
      class: `${_ctx.isRejectedActive ? 'bg-red-lp-100' : ''}`
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode("div", _hoisted_15, [
            _createVNode("div", {
              class: 
              `font-semibold text-12px ${
                _ctx.isRejectedActive ? 'text-white' : 'text-gray-lp-600'
              } whitespace-nowrap`
            
            }, _toDisplayString(_ctx.$t('dexAssessment.summaryDisputeRejected')), 3),
            _createVNode("div", {
              class: 
              `text-20px font-semibold ${_ctx.isRejectedActive ? 'text-white' : ''}`
            
            }, _toDisplayString(_ctx.data.ticketDisputeRejected) + "/" + _toDisplayString(_ctx.data.ticketInvalid), 3)
          ])
        ])
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_Card, {
      onClick: _cache[4] || (_cache[4] = () => _ctx.onClickSummary('accepted')),
      class: `${_ctx.isAcceptedActive ? 'bg-red-lp-100' : ''}`
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode("div", _hoisted_18, [
            _createVNode("div", {
              class: 
              `font-semibold text-12px ${
                _ctx.isAcceptedActive ? 'text-white' : 'text-gray-lp-600'
              } whitespace-nowrap`
            
            }, _toDisplayString(_ctx.$t('dexAssessment.summaryAcceptDex')), 3),
            _createVNode("div", {
              class: 
              `text-20px font-semibold ${_ctx.isAcceptedActive ? 'text-white' : ''}`
            
            }, _toDisplayString(_ctx.data.ticketDisputeAccepted) + "/" + _toDisplayString(_ctx.data.ticketInvalid), 3)
          ])
        ])
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}